import { mount } from '../dom-lifecycle';

const ANIMATING = 'is-animating';
const READY = 'is-ready';

/**
 * Kaskada wejścia elementów hero. Klasa `is-animating` włącza stan początkowy
 * (elementy ukryte) — dodajemy ją z JS-a, żeby przy braku JS hero po prostu
 * było widoczne zamiast zniknąć na zawsze. Klasa `is-ready` odpala keyframes.
 */
function bootHeader(header) {
    if (header.dataset.headerBooted === '1') return;
    header.dataset.headerBooted = '1';

    header.classList.add(ANIMATING);

    const start = () => requestAnimationFrame(() => {
        requestAnimationFrame(() => header.classList.add(READY));
    });

    // Slogan i logo to grafiki, ale CTA jest tekstem — czekamy na fonty, żeby
    // przycisk nie doanimował się w zastępczym kroju. Twardy fallback na wypadek
    // gdyby `fonts.ready` nigdy nie rozwiązało się (np. zablokowany webfont).
    if (document.fonts && document.fonts.ready) {
        let started = false;
        const go = () => {
            if (started) return;
            started = true;
            start();
        };
        document.fonts.ready.then(go);
        setTimeout(go, 1500);
    } else {
        start();
    }
}

mount('[data-header]', function () {
    bootHeader(this);
});
